import {API_FE_DOMAIN, API_FE_GET_USER_AND_INACTIVE_INFO, API_FE_VALIDATE_MOBILE} from "../constants";
import {SET_TELEPHONE_VALIDATION} from "../reducers";
import { put, call } from 'redux-saga/effects';
import axios from "axios";

export default function* getUserAndInactiveInfoSaga(action) {
    try {
        const result = yield call(() => axios.post(
            API_FE_DOMAIN + API_FE_GET_USER_AND_INACTIVE_INFO,
             action.payload,
            {
                headers: {
                    "Content-Type": "multipart/form-data",
                }
            }
        ));

        const response = result.data;

        if (response.status === 1) {
            yield put({
                type: SET_TELEPHONE_VALIDATION,
                payload: {
                    mobileMessage: 'success',
                    mobileUserInfo: null,
                    mobileErrorCode: null
                },
            });
        } else {
            const error = response.error;

            yield put({
                type: SET_TELEPHONE_VALIDATION,
                payload: {
                    mobileMessage: error.message,
                    mobileErrorCode: error.code,
                    mobileUserInfo: response.data != null && response.data.userInfo != null ?
                        response.data.userInfo : null
                },
            });
        }
    } catch (e) {
        console.log(e);
    }
}
